<div class="typeahead">
  <div class="typeahead-controls form-control" [class.dropdown-open]="showDropdown">
    <input
      #inputElement
      type="text"
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
      (keydown)="onKeyDown($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [attr.ngbAutoFocus]="ngbAutoFocus ? '' : null" />
    <span (click)="toggleDropdown()">
      @if (showDropdown) {
        <i class="bi bi-chevron-up"></i>
      } @else {
        <i class="bi bi-chevron-down"></i>
      }
    </span>
  </div>

  @if (!disabled && showDropdown) {
    <ul class="dropdown">
      @if (isGroupedData(filteredData)) {
        @for (group of filteredData; track group) {
          <li class="dropdown-group">
            <strong>{{ group.groupName }}</strong>
            <ul class="dropdown-group-items">
              @for (item of group.items; track item) {
                <li
                  class="dropdown-item"
                  [class.active]="selectedItem === item"
                  [engScrollIntoView]="selectedItem === item"
                  (click)="onSelect(item)">
                  {{ item.value }}
                </li>
              }
            </ul>
          </li>
        }
      }

      @if (isFlatData(filteredData)) {
        @for (item of filteredData; track item) {
          <li
            class="dropdown-item"
            [class.active]="selectedItem === item"
            [engScrollIntoView]="selectedItem === item"
            (click)="onSelect(item)">
            {{ item.value }}
          </li>
        }
      }
    </ul>
  }
</div>
